import React from "react";
import { Html } from "@react-three/drei";

import { useAppStore } from 'startup/appStore'
import { useShallow } from 'zustand/react/shallow'

export default function SelectPlayerButton({
    player,
    position,
}) {
    const { 
        currentPlayer,
        setPlayer,
        gameStatus,
        setGameStatus,
        setPositions,
        rabbitStartPosition,
        foxStartPosition,
    } = useAppStore( useShallow((state) => ({
        currentPlayer: state.player,
        setPlayer: state.setPlayer,
        gameStatus: state.gameStatus,
        setGameStatus: state.setGameStatus,
        setPositions: state.setPositions,
        rabbitStartPosition: state.positions['rabbit'].start,
        foxStartPosition: state.positions['fox'].start,
    })));

    const title = `play${currentPlayer === player ? 'ing' : ''} as ${player[0].toUpperCase()}${player.slice(1)}`

    // css styles
    const white = '#f9f9f9';
    const black = '#36383F';
    const gray = '#85888C';
    const green = '#3FB950';

    if (gameStatus !== 'beforeStart') return null;

    return (
        <Html
            position={position}
            //visible={gameStatus !== 'start'}
        >
            <div
                onClick={() => {
                    setPlayer(player);
                    setGameStatus('start');
                    setPositions('fox', foxStartPosition);
                    setPositions('rabbit', rabbitStartPosition);
                }}
                style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    backgroundColor: player === player ? green : black,
                    color: white,
                    border: 'none',
                    borderRadius: '50%',
                    boxShadow: `3px 3px 3px ${gray}`,
                    width: '100px',
                    height: '100px',
                    fontSize: '1rem',
                    cursor: 'pointer',
                    transition: 'all .2s ease-in-out',
                    padding: '20px',
                }}
            >
                {title}
            </div>
        </Html>
    );
};
